/**
* @Author: zachalam
* @Date:   2017-01-23T14:06:42-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-23T14:11:41-08:00
*/

import { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

class AuthRequiredContainer extends Component {

  constructor(props) {
    super(props);
    this.checkForProfile = this.checkForProfile.bind(this);
  }

  checkForProfile(props) {
    let profile = props.profile;
    if(_.isEmpty(profile) || (profile.profile === undefined)) {
      browserHistory.push("/join-profile");
    }
  }

  componentWillMount() {
    if(!this.props.auth.isAuthenticated) {
      // redirect unauthenticated users to login
      browserHistory.push("/login");
    }

  }

  render() {
    //Don't render the child of they aren't authenticated.
    //Fixes issue where calls were being made before being redirected.
    if(!this.props.auth.isAuthenticated) return null;
    else return this.props.children;
  }
}


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    profile: state.profile
  }
};


export default connect(mapStateToProps)(AuthRequiredContainer);



// WEBPACK FOOTER //
// ./src/containers/AuthRequiredContainer.jsx